<template>
  
    <el-col
      class="content"
      :xl="{ span: 18 }"
      :lg="{ span: 18 }"
      :md="{ span: 18 }"
      :xs="{ span: 24 }"
      :sm="{ span: 24 }"
    >
      <div class="mydoc">
        <div class="header" style="font-weight: 900">
          【实验语言学】云上论坛报告
        </div>
        <div class="mybody">
          <p>
            "实验语言学+"云上论坛直播报告的意义就是实验语言学的扩展，即，所有基于实证的语言学研究。除了生理实验、物理实验、心理实验，以及脑科学的实验和数学建模的仿真实验等等各种实验方法之外，还有田野调查、问卷调查、文献考证，以及利用数据库进行的语言研究。这就是建立在经验实证基础上的语言学。
          </p>
          <p>
            从2017年开始，一直到现在。每周两次网上报告并重播，寒假和暑假期间安排重播报告。每次报告都有数千个链接收看。欢迎大家都来参与。
          </p>
        </div>
      </div>
    </el-col>
    
  
</template>>

<script>
import loginComponent from "@/components/loginComponent";

export default {
  name: "forum",
  components: {
    loginComponent,
  },
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.el-row {
  //   background-color: white;
  margin: auto;
}

.introduction_pre {
  width: auto;
  margin: 10px 5px 10px 5px; /**边框距离 上右边下左 */
  background-color: white;
  overflow: hidden;
}
.introduction {
  border: 1px solid #b3c0d1;
  height: 920px;
  margin-bottom: 10px;
  border-radius: 5px;
  /* margin-top: 5px; */
}

.about {
  min-height: calc(100vh - 8rem);
}
.showappbox {
  display: flex;
  .left {
    text-align: left;
  }
}

.content {
  margin-top: 12px;
  .mylink {
    height: 18rem;
    border-radius: 4px;
    background: rgba($color: #ffffff, $alpha: 0.5);
    box-shadow: 2px 3px 10px rgb(51, 72, 94);
    .mybody {
      //   padding: 10px;
      display: flex;
      align-items: center;
      justify-content: space-around;
      .body-item {
        cursor: pointer;
      }
      .num {
        font-size: 55px;
        font-weight: bold;
      }
    }
  }
  .mydoc {
    border-radius: 4px;
    min-height: 20rem;
    box-shadow: 2px 3px 10px rgb(51, 72, 94);
    text-align: left;
    .mybody {
      //   background: linear-gradient(45deg, #34495e, #41b883);
      height: 940px;
      padding: 10px;
      background-color: white;
      overflow: auto;
    }
    p {
      color: black;
      text-indent: 30px;
      line-height: 24px;
      padding: 10px;
    }
  }
}
.header {
  padding: 10px;
  text-align: left;
  background-color: gainsboro;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  border-bottom: 1px solid gainsboro;
}
</style>


// WEBPACK FOOTER //
// src/view/forum.vue